import { ajax } from "../../app/core/ajax";
import { emptyFn } from "../core/util";

export function ping(args) {
    args = args || {};

    var success = args.success,
        error = args.error || emptyFn,
        unmask = args.unmask,
        guid = args.guid,
        curr = args.curr || 1,
        prev = args.prev || 0,
        errorHandled = args.errorHandled || false,
        correlationGroupId = args.correlationGroupId || kendo.guid();

    $.wait(curr * 1000).then(function () {
        ajax({
            url: "Executing/Ping?guid=" + guid,
            type: "POST",
            urlPrefix: args.urlPrefix,
            beforeSend: args.beforeSend,
            errorHandled: errorHandled,
            correlationGroupId: correlationGroupId
        }).done(function (data) {
            if (data.d.results) {
                success(data);
            } else {
                ping({
                    urlPrefix: args.urlPrefix,
                    beforeSend: args.beforeSend,
                    guid: guid,
                    success: success,
                    unmask: unmask,
                    error: error,
                    errorHandled: errorHandled,
                    curr: curr < 13 ? curr + prev : 13,
                    prev: curr < 13 ? curr - prev : prev,
                    correlationGroupId: correlationGroupId
                });
            }
        }).fail(function (data) {
            error(data);
        });
    });
}
